
import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Iframe } from "../components/Iframe";

export const ReportingView: React.FC = () => {
  const reportConfig = [
    {
      name: 'test report 2',
      url: process.env.REACT_APP_REPORT_URL,
      height: "950",
      width: "100%"
    }
  ]

  return (
    <Box sx={{ marginTop: '0px', marginLeft: '55px', width: { sm: '100%', md: '85%' } }}>
      <Paper>
        <Box>
          {
            reportConfig.map(({ width, height, url }) =>
            (
              <>
                {url && (<Iframe width={width} height={height} src={url} key={url} />)}
                {!url && (<Paper><Typography variant='h3' color={'error'}><FormattedMessage id='text.noReport' defaultMessage={"Report not configured"}/></Typography></Paper>)}
              </>
            )
            )
          }
        </Box>
      </Paper>
    </Box>
  );
};
